import { QuizForm } from '@/features/factory/subfactories/QuizForm'

/** Sub-route /factory/quiz — wraps the Quiz form component. */
export function QuizPage() {
  return <QuizForm />
}
